import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../contents/sequenceDiagram/Layout';
import SEO from '../../components/seo';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEO title="Sequence diagrams syntax" description="Learn to build sequence diagrams using simple code instead of drag-n-drop applications." mdxType="SEO" />
    <h1>{`UML Sequence diagram `}<em parentName="h1">{`Documentation`}</em></h1>
    <p>{`Learn to build sequence diagrams using a simple syntax. All the examples are interactive,
play around with the online editor to get started!`}</p>
    <h2>{`Participants`}</h2>
    <p>{`Participants are added in the order they appear.
You can force a particular order by adding `}<inlineCode parentName="p">{`participant`}</inlineCode>{` at the top.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sequence"
      }}>{`participant Bob

Alice->Bob: Hello
`}</code></pre>
    <p>{`You can alias participants using `}<inlineCode parentName="p">{`as`}</inlineCode>{` to shorten your code. Make sure to use quotes around the participant name.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sequence"
      }}>{`participant "Alice" as a
participant "Bob" as b

a->b: Hello
`}</code></pre>
    <h2>{`Messages`}</h2>
    <p>{`You can customize arrows style for each message with `}<inlineCode parentName="p">{`->`}</inlineCode>{` and `}<inlineCode parentName="p">{`-->`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sequence"
      }}>{`Alice->Bob: Hello
Bob-->Alice: Hi!
Alice->Alice: He said hi...
`}</code></pre>
    <p>{`You can create asynchronous messages using `}<inlineCode parentName="p">{`->>`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sequence"
      }}>{`Alice->>Bob: Asynchronous message
`}</code></pre>
    <p>{`You can also add latency to your messages using `}<inlineCode parentName="p">{`(<int>)`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sequence"
      }}>{`Alice->(1)Bob: Slow
Bob-->(4)Alice: Slower
`}</code></pre>
    <h2>{`Multi-lines and special characters`}</h2>
    <p>{`You can add line breaks by using `}<inlineCode parentName="p">{`\\n`}</inlineCode>{` or by adding quotes around your strings.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sequence"
      }}>{`Alice->Bob: Hello Bob\\nHow are you?
Bob->Alice: "Hi Alice
I'm great!"
`}</code></pre>
    <p>{`To use special characters in your strings you must use quotes. Special characters include `}<inlineCode parentName="p">{`:`}</inlineCode>{` `}<inlineCode parentName="p">{`,`}</inlineCode>{` `}<inlineCode parentName="p">{`-`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-sequence"
      }}>{`Alice->Bob: ":,-"
Bob->Alice: What?
`}</code></pre>
    <h2>{`Boxes`}</h2>
    <p>{`You can add boxes over one or multiple participants using `}<inlineCode parentName="p">{`box`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sequence"
      }}>{`box over Alice: Single participant
box over Alice,Bob: Multiple participants
`}</code></pre>
    <h2>{`Activation`}</h2>
    <p>{`You can activate participants using `}<inlineCode parentName="p">{`activate`}</inlineCode>{` and `}<inlineCode parentName="p">{`deactivate`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sequence"
      }}>{`Alice->Bob: Hello
activate Bob
Bob-->Alice: Hi!
deactivate Bob
`}</code></pre>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      